import { z } from "zod";

import { validationRecoveryCodeErrorMessages } from "../i18n/validation-error-codes.ts";

export const recoveryCodeSchema = z
  .string()
  .length(16, validationRecoveryCodeErrorMessages.invalidFormat.id)
  .regex(
    /^[A-Za-z0-9]+$/,
    validationRecoveryCodeErrorMessages.invalidFormat.id,
  );
